module.exports = __webpack_public_path__ + "img/资源 70.3821fac8.png";